<template>
    <div>
        <FindMemberIds/>
        <FindSurrogateId/>
        <BasicStatisticsRow basicstatisticspath="/2.0/newbe/statistics/surrogates?sessionid="/>
    </div>
</template>

<script>
import FindMemberIds from '../components/FindMemberIds.vue';
import FindSurrogateId from '../components/FindSurrogateId.vue';

export default {
    name: "ManageMemberIds",
  components: {
    FindMemberIds,
    FindSurrogateId
  },
}
</script>